// extracted by mini-css-extract-plugin
export var avatarContainer = "_ix-0";
export var avatarTypingWave = "_ix-i";
export var gray = "_ix-f";
export var green = "_ix-c";
export var icon = "_ix-9";
export var image = "_ix-1";
export var lg = "_ix-6";
export var md = "_ix-5";
export var presenceDot = "_ix-b";
export var red = "_ix-d";
export var sm = "_ix-4";
export var status = "_ix-a";
export var typingDot = "_ix-h";
export var typingPill = "_ix-g";
export var xl = "_ix-7";
export var xs = "_ix-3";
export var xxl = "_ix-8";
export var xxs = "_ix-2";
export var yellow = "_ix-e";